import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Box, Grid, Typography } from '@mui/material';

function Allbookingreport() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });
    const printRef = useRef();
    const [loading, setloading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");
    const [username, setusername] = useState("");
    const [bookingData, setbookingData] = useState([]);
    const [serviceData, setserviceData] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [total, settotal] = useState(0);
    const [propertyId, setpropertyId] = useState("");
    const [propData, setpropData] = useState({});

    const fethUsers = async () => {
        try {
            if (userData && loadincount) {
                const docRef = doc(db, "authroles", userData.uid);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    setusername(docSnap.data().username);
                    setpropertyId(docSnap.data().propertyId);   // ✅ store propertyId

                    const pid = docSnap.data().propertyId;

                    const propSnap = await getDoc(doc(db, "properties", pid));
                    if (propSnap.exists()) {
                        setpropData({ ...propSnap.data() });
                    }
                    setloadincount(false);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getReport = async () => {
        if (!fromDate || !toDate) {
            Toast.fire({ icon: "error", title: 'Please select From Date & To Date' });
            return;
        }

        if (!propertyId) {
            Toast.fire({ icon: "error", title: "Property not found" });
            return;
        }

        setloading(true);
        setbookingData([]);
        setpaymodes([]);
        setpayhistory([]);

        const startOfDay = new Date(fromDate);
        startOfDay.setHours(0, 0, 0, 0);
        const endOfDay = new Date(toDate);
        endOfDay.setDate(endOfDay.getDate() + 1);

        const reportStart = moment(fromDate).format('YYYY-MM-DD');
        const reportEnd = moment(toDate).format('YYYY-MM-DD');

        try {
            const [payhistorySnapshot, checkinDetailsSnapshot] = await Promise.all([
                getDocs(query(
                    collection(db, 'payhistory'),
                    where('status', '==', 'Working'),
                    where('propertyId', '==', propertyId)   // ✅ filter by property

                )),
                getDocs(query(
                    collection(db, 'checkindetails'),
                    where('status', 'in', ['Booked', 'Checkout']),
                    where('checkindate', '>=', reportStart),
                    where('checkindate', '<=', reportEnd),
                    where('propertyId', '==', propertyId)   // ✅ filter by property

                ))
            ]);

            

            const paymentHistoryData = await Promise.all(payhistorySnapshot.docs.map(async (doc1) => {
                const data = doc1.data();
                const [paymode1Snap, paymode2Snap] = await Promise.all([
                    getDoc(doc(db, "paymentmodes", data.paymode1)),
                    getDoc(doc(db, "paymentmodes", data.paymode2))
                ]);
                const paymode1 = paymode1Snap.exists() ? paymode1Snap.data().paymode : "";
                const paymode2 = paymode2Snap.exists() ? paymode2Snap.data().paymode : "";

                return {
                    id: doc1.id,
                    data,
                    paymode1,
                    paymode2,
                    amount1: data.amount1 || 0,
                    amount2: data.amount2 || 0,
                    createdat: moment(data.createdAt.toDate()).format('DD-MM-YYYY HH:mm:ss')
                };
            }));

            const checkinDetailsData = checkinDetailsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            

            const uniqueCheckinDetails = Array.from(new Map(checkinDetailsData.map(item => [item.bookingid, item])).values());
            const bookingIds = uniqueCheckinDetails.map(doc => doc.bookingid);
            if (bookingIds.length === 0) {
                setloading(false);
                return;
            }

            const chunkArray = (arr, size) =>
                arr.length <= size ? [arr] : [arr.slice(0, size), ...chunkArray(arr.slice(size), size)];

            const bookingChunks = chunkArray(bookingIds, 30);
            let bookingsDataMap = {};

            await Promise.all(bookingChunks.map(async (chunk) => {
                const q = query(collection(db, 'reservations'), where('__name__', 'in', chunk), where('propertyId', '==', propertyId));
                const snapshot = await getDocs(q);
                snapshot.docs.forEach(doc => {
                    bookingsDataMap[doc.id] = { id: doc.id, ...doc.data() };
                });
            }));

            const paymentHistoryMap = paymentHistoryData.reduce((acc, pay) => {
                const bookingId = pay.data.bookingid;
                if (bookingsDataMap[bookingId]) {
                    if (!acc[bookingId]) acc[bookingId] = [];
                    acc[bookingId].push(pay);
                }
                return acc;
            }, {});

            const combinedData = await Promise.all(uniqueCheckinDetails.map(async (checkinDetail) => {
                const bookingData = bookingsDataMap[checkinDetail.bookingid];
                if (!bookingData) return null;

                let username = "Unknown User";
                if (checkinDetail.uid) {
                    const userSnap = await getDoc(doc(db, "authroles", checkinDetail.uid));
                    if (userSnap.exists()) {
                        username = userSnap.data().username || "Unnamed User";
                    }
                }

                const roomamount = bookingData.rooamount || 0;
                const date1 = moment(bookingData.checkindate, 'YYYY-MM-DD');
                const date2 = moment(checkinDetail.checkindate, 'YYYY-MM-DD');
                let dayDifference = date2.diff(date1, 'days') || 1;
                const serviceamount = parseFloat(bookingData?.serviceamount) / parseFloat(bookingData.noofdays) || 0;

                let paymentHistory = paymentHistoryMap[checkinDetail.bookingid] || [];
                let paidAmount = paymentHistory.reduce((sum, pay) => sum + pay.amount1 + pay.amount2, 0);
                let totalamount = parseFloat(roomamount) + parseFloat(serviceamount);
                let alltoal = totalamount * dayDifference;
                let remaining = alltoal - paidAmount;

                // const hasAllowedPaymode = paymentHistory.some(item => item.data.paymode1 !== 'e97qx4fRL6swa99FcRBp' && item.data.paymode2 !== 'e97qx4fRL6swa99FcRBp');
                // if (!hasAllowedPaymode) return null;

                return {
                    ...checkinDetail,
                    booking: bookingData,
                    username,
                    serviceamount,
                    roomamount: roomamount.toFixed(0),
                    totalamount: totalamount.toFixed(0),
                    alltoal: alltoal.toFixed(0),
                    paidamount: paidAmount.toFixed(0),
                    pending: remaining.toFixed(0),
                    todayDays: dayDifference,
                    paymentHistory
                };
            }));

            setbookingData(combinedData.filter(item => item !== null));
        } catch (error) {
            console.error("Error fetching booking report:", error);
        } finally {
            setloading(false);
        }
    };



    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    const handleFromDate = (e) => {
        setfromDate(e.target.value)
        setloading(false)
    }
    const handleToDate = (e) => {
        settoDate(e.target.value)
        setloading(false)
    }


    const exportToExcel = () => {
        const sheetData = bookingData.map((item, index) => ({
            "Sr No": index + 1,
            "Customer Name": item.booking.customers?.custname || "",
            "Mobile": item.booking.customers?.mobile || "",
            "Checkin Date": `${moment(item.checkindate).format('DD/MM/YYYY')} ${item.checkintime}`,
            "Checkout Date": `${moment(item.checkoutdate).format('DD/MM/YYYY')} ${item.checkouttime}`,
            "Rooms": item.booking.rooms.map(r => `${r.roomname} (${parseFloat(r.discount)}%)`).join(", "),
            "Total": item.totalamount,
            "Payments": item.paymentHistory.length > 0
                ? item.paymentHistory.map(ph => {
                    const amt1 = parseFloat(ph.data.amount1) > 0 ? `${ph.paymode1}: ${parseFloat(ph.data.amount1).toFixed(0)}` : "";
                    const amt2 = parseFloat(ph.data.amount2) > 0 ? `${ph.paymode2}: ${parseFloat(ph.data.amount2).toFixed(0)}` : "";
                    return [amt1, amt2].filter(Boolean).join(" / ");
                }).join("\n")
                : "Pending"
        }));

        const worksheet = XLSX.utils.json_to_sheet(sheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Booking Report");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blobData = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blobData, `Booking_Report_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
    };


    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " >|| All Booking Report ||</button><br /><br />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label>From Date</label>
                                                <input type='date' value={fromDate} onChange={handleFromDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-4'>
                                                <label>To Date</label>
                                                <input type='date' value={toDate} onChange={handleToDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-3'>
                                                <br />
                                                <button className='btn btn-info' onClick={getReport}>Get Report</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card card-primary card-outline" ref={printRef}>
                                    <div className="card-body">
                                        <Box p={1} mb={2}>
                                            <Grid className="row" alignItems="center">
                                                <Grid className="col-sm-12" textAlign="center">
                                                    <Typography variant="h5" fontWeight="bold"
                                                        style={{ textTransform: "uppercase", color: "red" }}>{propData.hotelname}</Typography>
                                                    <Typography variant="subtitle2">
                                                        GSTIN No - {propData.gstno}
                                                    </Typography>
                                                    <Typography>
                                                        {propData.address} {propData.city} {propData.state} {propData.pincode}
                                                        <br />
                                                        Phone: +91 {propData.mobile} | Email: {propData.email}
                                                        <br />
                                                        {/* Website: {propData.website} */}
                                                    </Typography>
                                                </Grid>

                                            </Grid>
                                        </Box>
                                        <div className='row'>
                                            <table className='customers '>
                                                <tr>
                                                    <th style={{ textAlign: "center" }}>From Date : {moment(fromDate).format('DD/MM/YYYY')}  </th>
                                                    <th style={{ textAlign: "center" }}><h5>BOOKING REPORT </h5></th>
                                                    <th style={{ textAlign: "center" }}>To Date : {moment(toDate).format('DD/MM/YYYY')}</th>
                                                </tr>
                                            </table>

                                            <table className="customers" style={{ width: "100%", borderCollapse: "collapse" }}>
                                                <thead>
                                                    <tr>
                                                        <th>Sr No</th>
                                                        <th>Customer Name</th>
                                                        <th>Mobile</th>
                                                        <th>Checkin Date</th>
                                                        <th>Checkout Date</th>
                                                        <th>Rooms</th>
                                                        {/* <th style={{ textAlign: "right" }}>Amount</th> */}
                                                        {/* <th style={{ textAlign: "right" }}>Extra</th> */}
                                                        <th style={{ textAlign: "right" }}>Total</th>
                                                        <th style={{ textAlign: "center" }}>Payments</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bookingData.map((item, index) => {
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <tr>
                                                                    <td>{index + 1}</td>
                                                                    <td style={{ textTransform: "capitalize" }}>{item.booking.customers.custname}</td>
                                                                    <td>{item.booking.customers.mobile}</td>
                                                                    <td>{moment(item.checkindate).format('DD/MM/YYYY')} {item.checkintime}</td>
                                                                    <td>{moment(item.checkoutdate).format('DD/MM/YYYY')} {item.checkouttime}</td>
                                                                    <td>
                                                                        {item.booking.rooms.map((room, idx) => (
                                                                            <span key={idx}>
                                                                                {room.roomname} ({parseFloat(room.discount)}%)<br />
                                                                            </span>
                                                                        ))}
                                                                    </td>
                                                                    {/* <td style={{ textAlign: "right" }}>{item.roomamount}</td> */}
                                                                    {/* <td style={{ textAlign: "right" }}>{item.serviceamount}</td> */}
                                                                    <td style={{ textAlign: "right" }}>{item.totalamount}</td>
                                                                    <td style={{ textAlign: "right" }}>
                                                                        {item.paymentHistory.length > 0 ? (
                                                                            <>
                                                                                {item.paymentHistory.map((ph, idx) => (
                                                                                    <div key={idx}>
                                                                                        {parseFloat(ph.data.amount1) > 0 &&
                                                                                            <b>{ph.paymode1} : {parseFloat(ph.data.amount1).toFixed(0)}<br /></b>}
                                                                                        {parseFloat(ph.data.amount2) > 0 &&
                                                                                            <b>{ph.paymode2} : {parseFloat(ph.data.amount2).toFixed(0)}</b>}
                                                                                    </div>
                                                                                ))}
                                                                            </>
                                                                        ) : (
                                                                            <b style={{ color: "red" }}>Pending</b>
                                                                        )}
                                                                    </td>
                                                                </tr>

                                                                {/* Insert total row AFTER last item */}
                                                                {index === bookingData.length - 1 && (
                                                                    <tr style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
                                                                        <td colSpan={6} style={{ textAlign: "right" }}>Total</td>
                                                                        {/* <td style={{ textAlign: "right" }}>
                                                                            {bookingData.reduce((sum, row) => sum + parseFloat(row.roomamount), 0).toFixed(0)}
                                                                        </td>
                                                                        <td style={{ textAlign: "right" }}>
                                                                            {bookingData.reduce((sum, row) => sum + parseFloat(row.serviceamount), 0).toFixed(0)}
                                                                        </td> */}
                                                                        <td style={{ textAlign: "right" }}>
                                                                            {bookingData.reduce((sum, row) => sum + parseFloat(row.totalamount), 0).toFixed(0)}
                                                                        </td>
                                                                        <td></td>
                                                                    </tr>
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </tbody>

                                            </table>


                                        </div>
                                    </div>

                                </div>
                                <center>
                                    <button className='btn btn-success' onClick={handlePrint}>Print Report</button>&nbsp;
                                    {/* <button className='btn btn-primary' onClick={exportToExcel}>Download Excel</button> */}
                                </center>
                            </div>
                        </div>
                    </div>
                </section >

            </div>

        </div >

    )
}

export default Allbookingreport
